import GroupIcon from "@/assets/dark_gradient/group.svg?react";
import Button from "@/components/Common/Button";
import {useIsCompany} from "@/hooks/useUserHooks";
import {Can} from "@/permissions";
import {useNavigate} from "@tanstack/react-router";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const EnableMultiAccountCta: FC = () => {
  const {t} = useTranslation("multi_account");
  const navigate = useNavigate();
  const isCompany = useIsCompany();

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="border-neutral-grey-light-dark flex flex-col items-center justify-center gap-2 rounded-md border px-5 py-3 text-center">
        <GroupIcon className="size-6 shrink-0" />
        <span className="bg-linear-(--primary-dark-gradient) bg-clip-text text-xl font-semibold text-transparent">
          {t("multiaccount_cta_title")}
        </span>
        <span className="text-neutral-black text-xs">{t("multiaccount_cta_description")}</span>
      </div>
      {isCompany && (
        <Can I="create" a="MailToSupport">
          <Button onClick={() => navigate({to: "/plans"})} buttonStyle="Blue" className="h-auto self-stretch px-8 py-3">
            {t("purchase_plan")}
          </Button>
        </Can>
      )}
    </div>
  );
};

export default EnableMultiAccountCta;
